import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import JsonSchemaForm from 'react-jsonschema-form';
import CheckboxWidget from './CheckboxWidget';

const Base = styled.div`
  .checkbox, .checkbox-inline {
    margin-right: 1em;
    input {
      margin-right: 0.3em;
    }
  }
  .radio, .radio-inline {
    margin-right: 1em;
    input {
      margin-right: 0.3em;
    }
  }
  .field-description {
    font-size: 0.8em;
    opacity: 0.8;
  }
  .form-control:disabled {
    background: transparent;
    border: 0;
  }
  .control-label {
    font-size: 0.9em;
    color: gray;
  }
`;

const Buttons = styled.div.attrs({
  className: 'buttons',
})`
  button:not(:nth-last-child(1)) {
    margin-right: 0.75rem;
  }
`;

const SubmitButton = styled.button.attrs({
  className: 'btn btn-primary submit-button',
  type: 'submit',
  children: 'Save',
})``;

export default function Form({
  data, disabled, children, ...props
}) {
  return (
    <Base>
      <JsonSchemaForm
        {...props}
        formData={data}
        disabled={disabled}
        widgets={{
          CheckboxWidget,
        }}
      >
        <Buttons>
          {
            children || (
              <SubmitButton />
            )
          }
        </Buttons>
      </JsonSchemaForm>
    </Base>
  );
}

Form.propTypes = {
  data: PropTypes.shape({}),
  disabled: PropTypes.bool,
  showErrors: PropTypes.bool,
  agreed: PropTypes.bool,
  children: PropTypes.node,
};

Form.defaultProps = {
  data: undefined,
  disabled: false,
  showErrors: false,
  children: undefined,
  agreed: false,
};
